import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

/**
 * @param {{
 *    className: string
 *    noPadding: boolean
 * }} props
 * @returns {React.Component}
 */
const ZariLabel = ({ text, className, noPadding, ...props }) => {
  return (
    <p
      {...props}
      className={clsx('zr-onlytext', className, {
        'no-padding': noPadding
      })}
    >
      {text}
    </p>
  )
}

ZariLabel.propTypes = {
  className: PropTypes.string,
  noPadding: PropTypes.bool,
  text: PropTypes.string
}

export default ZariLabel
